module.exports = __webpack_public_path__ + "static/media/schedule.c92c6395.svg";